export default __webpack_public_path__ + "images/referenzen/imagefilm/easycredit_kampagnefilm_daguckste.mp4";